import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fe17184e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo logo-title"
}, "安徽达链", -1));
const _hoisted_2 = {
  class: "menu"
};
const _hoisted_3 = {
  class: "service"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "info-item-title me-content-ml"
}, "7*24小时客服"), /*#__PURE__*/_createElementVNode("span", {
  class: "info-item me-content"
}, "400-993-7878")], -1));
const _hoisted_5 = {
  class: "menu-content me-padding-H2"
};
const _hoisted_6 = {
  class: "figure-freight"
};
const _hoisted_7 = {
  class: "figure-link"
};
const _hoisted_8 = {
  class: "menu-item-second"
};
const _hoisted_9 = {
  class: "figure-enertgy"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menu-item-second"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_Space = _resolveComponent("Space");
  const _component_Divider = _resolveComponent("Divider");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "header-content",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_a_tabs, {
    activeKey: _ctx.activeKey,
    "onUpdate:activeKey": _cache[4] || (_cache[4] = $event => _ctx.activeKey = $event),
    onChange: _ctx.tabChangeHandle,
    tabBarGutter: _ctx.tabBarGutter,
    class: "header-tab"
  }, {
    default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
      key: "home"
    }, {
      tab: _withCtx(() => [_createElementVNode("label", {
        class: "tab-item",
        onMouseenter: _cache[0] || (_cache[0] = $event => _ctx.menuHoverHandle('home'))
      }, "首页", 32)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "product"
    }, {
      tab: _withCtx(() => [_createElementVNode("label", {
        class: "tab-item",
        onMouseenter: _cache[1] || (_cache[1] = $event => _ctx.menuHoverHandle('product'))
      }, "产品与解决方案", 32)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "project"
    }, {
      tab: _withCtx(() => [_createElementVNode("label", {
        class: "tab-item",
        onMouseenter: _cache[2] || (_cache[2] = $event => _ctx.menuHoverHandle('project'))
      }, "客户案例", 32)]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "us"
    }, {
      tab: _withCtx(() => [_createElementVNode("label", {
        class: "tab-item",
        onMouseenter: _cache[3] || (_cache[3] = $event => _ctx.menuHoverHandle('us'))
      }, "关于我们", 32)]),
      _: 1
    })]),
    _: 1
  }, 8, ["activeKey", "onChange", "tabBarGutter"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_Space, {
    size: _ctx.spaceSize
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }, 8, ["size"])])], 4), _createElementVNode("div", {
    class: _normalizeClass(["children-menu", {
      'show-children-menu': _ctx.active
    }]),
    onMouseleave: _cache[12] || (_cache[12] =
    //@ts-ignore
    (...args) => _ctx.childrenMenuMouseLeave && _ctx.childrenMenuMouseLeave(...args))
  }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: _normalizeClass(["menu-item-first", {
      'active-second': _ctx.activeSecondMenu === 'figure-freight'
    }]),
    onClick: _cache[5] || (_cache[5] = $event => _ctx.menuClickHandle('figure-freight'))
  }, "数字货运", 2), _createVNode(_component_Divider, {
    class: "divider"
  })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: _normalizeClass([{
      'active-second': _ctx.activeModluesMenu === 'figure-link'
    }, "menu-item-first"]),
    onClick: _cache[6] || (_cache[6] = $event => _ctx.menuClickHandle('figure-link'))
  }, "数字供应链", 2), _createVNode(_component_Divider, {
    class: "divider"
  }), _createElementVNode("div", _hoisted_8, [_createElementVNode("label", {
    class: _normalizeClass({
      'active-second': _ctx.activeSecondMenu === 'coal'
    }),
    onClick: _cache[7] || (_cache[7] = $event => _ctx.menuClickHandle('coal'))
  }, "煤炭行业", 2), _createElementVNode("label", {
    class: _normalizeClass({
      'active-second': _ctx.activeSecondMenu === 'chemical'
    }),
    onClick: _cache[8] || (_cache[8] = $event => _ctx.menuClickHandle('chemical'))
  }, "化工行业", 2), _createElementVNode("label", {
    class: _normalizeClass({
      'active-second': _ctx.activeSecondMenu === 'power'
    }),
    onClick: _cache[9] || (_cache[9] = $event => _ctx.menuClickHandle('power'))
  }, "电力行业", 2), _createElementVNode("label", {
    class: _normalizeClass({
      'active-second': _ctx.activeSecondMenu === 'rail'
    }),
    onClick: _cache[10] || (_cache[10] = $event => _ctx.menuClickHandle('rail'))
  }, "铁路货站", 2)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["menu-item-first", {
      'active-second': _ctx.activeSecondMenu === 'figure-enertgy'
    }]),
    onClick: _cache[11] || (_cache[11] = $event => _ctx.menuClickHandle('figure-enertgy'))
  }, "数字能源", 2), _createVNode(_component_Divider, {
    class: "divider"
  }), _hoisted_10])])], 34)], 64);
}